import Vue from 'vue';
import customWorld from '@/components/charts/chartMap/highchartsMap/world.json';

export default Vue.extend({
  name: 'HightchartsConstructor',
  template: '<div ref="chart"></div>',
  render: (createElement) => createElement('div', {
    ref: 'chart',
  }),
  props: {
    constructorType: {
      type: String,
      default: 'chart',
    },
    options: {
      type: Object,
      required: true,
    },
    updateArgs: {
      type: Array,
      default: () => [true, true],
    },
    deepCopyOnUpdate: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    options: {
      handler () {
        this.$nextTick(() => {
          this.chart.update({ ...this.options }, ...this.updateArgs);
          this.chart.reflow();
        });
      },
      deep: true,
    },
  },
  methods: {
    createChart(chart) {
      this.chart = chart[this.constructorType](
        this.$refs.chart,
        { ...this.options }, // Always pass the deep copy when generating a chart. #80
        () => {
          this.$emit('loaded');
        },
      );
      this.$nextTick(() => {
        this.chart.reflow();
      });
    },
  },
  mounted () {
    let charts;
    if (this.constructorType.includes('map')) {
      charts = require('highcharts/highmaps');
      charts.maps['custom/world'] = customWorld;
    } else {
      charts = require('highcharts');
      require('highcharts/highcharts-more.js')(charts);
    }
    require('highcharts/modules/exporting')(charts);
    require('highcharts/modules/solid-gauge')(charts);
    charts.Pointer.prototype.reset = function () {
      return undefined;
    };
    this.createChart(charts);
  },
  beforeDestroy () {
    // Destroy chart if exists
    if (this.chart) {
      this.chart.destroy();
    }
  },
});
